import { supabase } from '@/lib/supabase/client';
import { outreachSafetyMatchesSuccessSchema } from '@/lib/outreach-safety/match-contract';
import type { LeadOutreachSafetyMatch } from '@/types/leads';

async function getAccessToken(): Promise<string> {
  const { data, error } = await supabase.auth.getSession();
  if (error || !data.session?.access_token) {
    throw new Error('Sign in again before loading lead safety evidence.');
  }
  return data.session.access_token;
}

export const outreachSafetyService = {
  async listMatchesByLeadId(leadId: string): Promise<LeadOutreachSafetyMatch[]> {
    const accessToken = await getAccessToken();
    const response = await fetch(
      `/api/outreach-safety-matches?leadId=${encodeURIComponent(leadId)}`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    const payload = await response.json().catch(() => null);
    if (!response.ok) {
      throw new Error(payload?.error?.message || `Lead safety match evidence is unavailable (${response.status}).`);
    }
    const parsed = outreachSafetyMatchesSuccessSchema.safeParse(payload);
    if (!parsed.success || parsed.data.matches.some((match) => match.lead_id !== leadId.toLowerCase())) {
      throw new Error('Lead safety match response is invalid.');
    }
    return parsed.data.matches;
  },
};
